export function SegmentEventLog() {
  return (
    <div>TODO: Display a log of called segment events with their payloads</div>
  );
}
